import FounderForm from "../component/FounderForm";
const AddNewFounder = () => { return (<FounderForm />) }
export default AddNewFounder;